import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    static targets = [
        "image"
    ]

    static values = {
        images: Array,
        size: Number,
        minSize: Number,
        maxSize: Number
    }

    connect(){

    console.log("imagesValue raw:", this.imagesValue)
        this.index = 0

        this.currentX = this.element.clientWidth / 2
        this.currentY = this.element.clientHeight / 2

        this.targetX = this.currentX
        this.targetY = this.currentY

        this.currentRadius = this.sizeValue
        this.targetRadius = this.sizeValue

        this.followSpeed = 0.15
        this.zoomSpeed = 0.12

        this.imageTarget.style.backgroundImage =
            `url(${this.imagesValue[this.index]})`

        this.pointer = this.pointer.bind(this)
        this.wheel = this.wheel.bind(this)
        this.click = this.click.bind(this)
        this.animate = this.animate.bind(this)

        this.element.addEventListener(
            "pointermove",
            this.pointer
        )

        this.element.addEventListener(
            "wheel",
            this.wheel,
            { passive:false }
        )

        this.element.addEventListener(
            "click",
            this.click
        )

        this.frame =
            requestAnimationFrame(this.animate)

    }

    disconnect(){

        cancelAnimationFrame(this.frame)

        this.element.removeEventListener(
            "pointermove",
            this.pointer
        )

        this.element.removeEventListener(
            "wheel",
            this.wheel
        )

        this.element.removeEventListener(
            "click",
            this.click
        )

    }

    pointer(event){

        const rect =
            this.element.getBoundingClientRect()

        this.targetX =
            event.clientX - rect.left

        this.targetY =
            event.clientY - rect.top

    }

    wheel(event){

        event.preventDefault()

        if(event.deltaY < 0){

            this.targetRadius *= 1.08

        }else{

            this.targetRadius *= 0.92

        }

        this.targetRadius = Math.max(

            this.minSizeValue,

            Math.min(
                this.maxSizeValue,
                this.targetRadius
            )

        )

    }

    click(){

        this.index++

        if(this.index >= this.imagesValue.length){

            this.index = 0

        }

        this.imageTarget.style.backgroundImage =
            `url(${this.imagesValue[this.index]})`

    }

    lerp(start,end,amount){

        return start + (end-start)*amount

    }

    animate(){

        this.currentX =
            this.lerp(
                this.currentX,
                this.targetX,
                this.followSpeed
            )

        this.currentY =
            this.lerp(
                this.currentY,
                this.targetY,
                this.followSpeed
            )

        this.currentRadius =
            this.lerp(
                this.currentRadius,
                this.targetRadius,
                this.zoomSpeed
            )

        this.element.style.setProperty(
            "--x",
            `${this.currentX}px`
        )

        this.element.style.setProperty(
            "--y",
            `${this.currentY}px`
        )

        this.element.style.setProperty(
            "--radius",
            `${this.currentRadius}px`
        )

        this.frame =
            requestAnimationFrame(
                this.animate
            )

    }

}